/* ==========================================================================
   Color bar + info band — sections/color-bar-banner.liquid
   <color-bar-banner> custom element.
     * interaction="fluid", desktop: the strip is a fluidized bed of fine powder grains (canvas, about 35,000 grains at
       1240 px wide on a 2x screen), drawn at rest on load. The cursor blows grains away in a plume and they spring
       back. Nothing else moves it (no settle-in, no scroll slosh). Static under prefers-reduced-motion.
     * Touch devices: no canvas at all. The chips show their colors; touching one shows its name in a bubble above
       it (as the old bar did on hover) and a tap opens the color.
     * Every chip and card click publishes `color_bar_click` (Shopify Customer Events, gtag, dataLayer).
       Never preventDefault: links keep working when analytics is blocked or declined.
   ========================================================================== */
(function () {
  'use strict';
  if (window.customElements && window.customElements.get('color-bar-banner')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touchOnly = window.matchMedia('(hover: none)').matches;

  /* ------------------------------------------------------------- analytics */
  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false;
    } catch (e) { /* fall through */ }
    return true;
  }
  function track(eventName, params) {
    if (window.__dbBotDetected) return;
    var payload = Object.assign({}, params || {});
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, payload);
      }
      if (!analyticsAllowed()) return;
      if (typeof window.gtag === 'function') window.gtag('event', eventName, payload);
      if (window.dataLayer && typeof window.dataLayer.push === 'function' && !window.dataLayer.__dbStubbed) {
        window.dataLayer.push(Object.assign({ event: eventName }, payload));
      }
    } catch (e) { /* analytics must never break the page */ }
  }

  /* ------------------------------------------------------------- fluidized bed (desktop only) */
  function initFluid(root) {
    var strip = root.querySelector('.dbcb__strip'), cv = root.querySelector('.dbcb__fluidcv');
    if (!strip || !cv) return;
    if (reduceMotion) { root.classList.add('is-static'); return; }
    var dpr = Math.min(window.devicePixelRatio || 1, 2), G = dpr >= 2 ? 1.5 : 2;
    // R is the plume radius: the cursor is the gun tip and grains inside R are blown outward, hardest at the centre.
    // A wider R moves the same grains further (no extra grains), which reads as a spray plume rather than a fingertip.
    // The bed is drawn at rest on load (no settle-in) and only the cursor moves it (no scroll slosh): Thomas, 2026-09-26.
    var PAD = 140, R = 200, K = 1.0, SPRING = 0.085, DAMP = 0.78, JIT = 0.35;
    var W = 0, H = 0, chips = [], mouse = null, raf = 0, running = false;

    function build() {
      var r = strip.getBoundingClientRect();
      W = Math.round(r.width); H = Math.round(r.height) + PAD * 2;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      cv.getContext('2d').setTransform(dpr, 0, 0, dpr, 0, 0);
      chips = [];
      strip.querySelectorAll('.dbcb__chip').forEach(function (chip) {
        var c = chip.getBoundingClientRect(), x0 = c.left - r.left, y0 = c.top - r.top + PAD, w = c.width, h = c.height, n = 0;
        var cols = Math.ceil(w / G), rows = Math.ceil(h / G), N = cols * rows;
        var hx = new Float32Array(N), hy = new Float32Array(N), x = new Float32Array(N), y = new Float32Array(N), vx = new Float32Array(N), vy = new Float32Array(N);
        var sx = Math.round(x0 * dpr) / dpr, sy = Math.round(y0 * dpr) / dpr;
        for (var j = 0; j < rows; j++) for (var i = 0; i < cols; i++) { hx[n] = sx + i * G; hy[n] = sy + j * G; x[n] = hx[n]; y[n] = hy[n]; n++; }
        chips.push({ color: chip.dataset.hex, hx: hx, hy: hy, x: x, y: y, vx: vx, vy: vy, n: n, x0: x0, x1: x0 + w, awake: false });
      });
      draw();
    }
    function draw() {
      var ctx = cv.getContext('2d'), GS = G + 1 / dpr;
      ctx.clearRect(0, 0, W, H);
      for (var c = 0; c < chips.length; c++) {
        var ch = chips[c];
        ctx.fillStyle = ch.color;
        for (var i = 0; i < ch.n; i++) ctx.fillRect(Math.round(ch.x[i] * dpr) / dpr, Math.round(ch.y[i] * dpr) / dpr, GS, GS);
      }
    }
    function step() {
      var any = false;
      for (var c = 0; c < chips.length; c++) {
        var ch = chips[c];
        var near = mouse && mouse.x > ch.x0 - R && mouse.x < ch.x1 + R;   // only chips near the cursor can be disturbed
        if (!near && !ch.awake) continue;
        var moving = false;
        for (var i = 0; i < ch.n; i++) {
          var dx = ch.x[i] - ch.hx[i], dy = ch.y[i] - ch.hy[i], vx = ch.vx[i], vy = ch.vy[i];
          if (near) {
            var px = ch.x[i] - mouse.x, py = ch.y[i] - mouse.y, d = Math.sqrt(px * px + py * py);
            if (d < R) { var f = 1 - d / R; f = f * Math.sqrt(f) * K; if (d < 0.01) { px = 1; py = 0; d = 1; } vx += px / d * f * 7; vy += py / d * f * 7; }
            else if (JIT && d < R * 1.6) { vx += (Math.random() - 0.5) * JIT; vy += (Math.random() - 0.5) * JIT; }
          }
          vx = (vx - dx * SPRING) * DAMP; vy = (vy - dy * SPRING) * DAMP;
          var nx = ch.x[i] + vx, ny = ch.y[i] + vy;
          if (Math.abs(nx - ch.hx[i]) < 0.04 && Math.abs(ny - ch.hy[i]) < 0.04 && Math.abs(vx) < 0.02 && Math.abs(vy) < 0.02) { nx = ch.hx[i]; ny = ch.hy[i]; vx = 0; vy = 0; }
          else moving = true;
          ch.x[i] = nx; ch.y[i] = ny; ch.vx[i] = vx; ch.vy[i] = vy;
        }
        ch.awake = moving; if (moving) any = true;
      }
      draw();
      if (any || mouse) raf = requestAnimationFrame(step); else running = false;
    }
    function go() { if (!running) { running = true; raf = requestAnimationFrame(step); } }
    function at(clientX, clientY) { var r = strip.getBoundingClientRect(); return { x: clientX - r.left, y: clientY - r.top + PAD }; }

    strip.addEventListener('mousemove', function (e) { mouse = at(e.clientX, e.clientY); go(); });
    strip.addEventListener('mouseleave', function () { mouse = null; go(); });
    if (window.ResizeObserver) new ResizeObserver(function () { cancelAnimationFrame(raf); running = false; build(); }).observe(strip);
    // A page restored from the back/forward cache comes back with the loop dead: forget the cursor and let the bed settle.
    function restart() { mouse = null; cancelAnimationFrame(raf); running = false; go(); }
    window.addEventListener('pagehide', function () { mouse = null; });
    window.addEventListener('pageshow', restart);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') restart(); else mouse = null; });
    root.classList.add('is-live');   // CSS swaps the chips to bare metal only once the bed is drawn
    build();
  }

  /* ------------------------------------------------------------- touch devices: static strip, name bubble on touch */
  function initTouch(root) {
    root.classList.add('is-touch');
    var timer = 0;
    function clear() { root.querySelectorAll('.dbcb__chip.is-touched').forEach(function (c) { c.classList.remove('is-touched'); }); }
    root.addEventListener('touchstart', function (e) {
      var chip = e.target.closest('.dbcb__chip');
      if (!chip) return;
      clear(); chip.classList.add('is-touched');
      clearTimeout(timer); timer = setTimeout(clear, 1500);
    }, { passive: true });
    document.addEventListener('touchstart', function (e) { if (!e.target.closest('.dbcb__strip')) clear(); }, { passive: true });
  }

  /* ------------------------------------------------------------- the element */
  var ColorBarBanner = function () { return Reflect.construct(HTMLElement, [], ColorBarBanner); };
  ColorBarBanner.prototype = Object.create(HTMLElement.prototype);
  ColorBarBanner.prototype.constructor = ColorBarBanner;

  ColorBarBanner.prototype.connectedCallback = function () {
    if (this._bound) return;
    this._bound = true;
    var self = this;

    this.addEventListener('click', function (event) {
      var chip = event.target.closest('.dbcb__chip');
      if (chip) { track('color_bar_click', { target: 'color', color: chip.dataset.color || '', href: chip.href }); return; }
      var card = event.target.closest('.dbcb__card');
      if (card) track('color_bar_click', { target: 'card', card: card.dataset.card || '', href: card.href });
    });

    if (this.dataset.interaction === 'fluid') { if (touchOnly) initTouch(this); else initFluid(this); }
  };

  window.customElements.define('color-bar-banner', ColorBarBanner);
})();
